import { DATE_FORMAT } from '@gat-ship/types'
import { Temporal } from '@js-temporal/polyfill'

export function isCurrentMonth(date: Temporal.ZonedDateTime, timeZone?: string) {
  const isCurrentMonth = date?.month === Temporal.Now.zonedDateTimeISO(timeZone).month
  return isCurrentMonth
}

export function isPreviousDay(date: Temporal.ZonedDateTime, timeZone?: string) {
  return date?.day < Temporal.Now.zonedDateTimeISO(timeZone).day
}

export function isValidMonth(month: number): boolean {
  // Month must be between 1 and 12
  return month >= 1 && month <= 12
}

export function isValidYear(year: number): boolean {
  // Year must be reasonable (e.g., between 1900 and 2100)
  return year >= 1900 && year <= 2100
}

export function isValidHour(hour: number): boolean {
  return hour >= 0 && hour <= 23
}

export function isValidMinute(minute: number): boolean {
  return minute >= 0 && minute <= 59
}

export function isValidDay(day: number, month?: number, year?: number): boolean {
  // Basic validation: day must be between 1 and 31
  if (day < 1 || day > 31) return false

  try {
    // Get current date/time if month/year not provided
    const now = Temporal.Now.zonedDateTimeISO()
    const targetMonth = month ?? now.month
    const targetYear = year ?? now.year

    // Create a Temporal.PlainDate to validate the date
    const testDate = Temporal.PlainDate.from({
      year: targetYear,
      month: targetMonth,
      day: day
    })

    // If we get here, the date is valid
    return true
  } catch {
    // If Temporal.PlainDate.from throws, the date is invalid
    return false
  }
}

export function getYearFromString(year: string | undefined): number {
  if (!year) return Temporal.Now.zonedDateTimeISO().year
  if (year.length === 1) {
    // Single digit year - assume it's 2000s
    return 2000 + Number(year)
  } else if (year.length === 2) {
    // Two digit year - assume it's 2000s
    return 2000 + Number(year)
  }
  return Number(year)
}

export function formatDate(date: Temporal.ZonedDateTime, locale: string, dateOnly = false) {
  return date
    .toLocaleString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: dateOnly ? undefined : '2-digit',
      minute: dateOnly ? undefined : '2-digit'
    })
    .replace(',', '')
}
